import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, resolveComponent as _resolveComponent, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-330da049"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "admin-chat" }
const _hoisted_2 = { class: "title leksa_title fz20 flex-center-between" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Чаты с клиентами", -1))
const _hoisted_4 = {
  key: 0,
  class: "chats"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_common_chat = _resolveComponent("common-chat")!
  const _component_chat_main = _resolveComponent("chat-main")!

  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      (_ctx.selectedChat)
        ? (_openBlock(), _createElementBlock("button", {
            key: 0,
            class: "btn btn--main btn--small",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.selectedChat = null))
          }, "Назад"))
        : _createCommentVNode("", true)
    ]),
    (!_ctx.selectedChat)
      ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.chats, (chat) => {
            return (_openBlock(), _createBlock(_component_common_chat, {
              key: chat,
              chat: chat,
              user: _ctx.user._id,
              onOpenChat: ($event: any) => (_ctx.openChat(chat)),
              onDeleteChat: ($event: any) => (_ctx.deleteChat(chat._id))
            }, null, 8, ["chat", "user", "onOpenChat", "onDeleteChat"]))
          }), 128))
        ]))
      : (_openBlock(), _createBlock(_component_chat_main, {
          key: 1,
          chat: _ctx.selectedChat,
          user: _ctx.user._id
        }, null, 8, ["chat", "user"]))
  ]))
}